import { renderCellCpfCnpj } from "../../../../utils/table-render-functions"

export const COLUMNS_MODAL_TABLE_CNPJ = [
    { field: "CPFCNPJ", headerName: "CPFCNPJ", width: 200, renderCell: (params) => renderCellCpfCnpj(params) },
    { field: "CodigoCVM", headerName: "Código CVM", width: 200 },
    { field: "Ticker", headerName: "Ticker B3", width: 200 },
    { field: "RazaoSocial", headerName: "Razão Social", width: 300 },
    { field: "NomeFantasia", headerName: "Nome Fantasia", width: 300 },
    { field: "Setor", headerName: "Setor", width: 300 },
    { field: "SubSetor", headerName: "SubSetor", width: 300 },
    {
        field: "GrupoEconomico_Nome",
        headerName: "Grupo Econômico",
        width: 300,
    },
]

export const INITIAL_STATE_DATALAKE_COMPANY = {
    companies: [],
    selectedCompany: null,
    isLoadingCompanies: false,
    companiesError: null,
    isFullListModalOpen: false,
    lastFetched: null,
}

export const CONFIG_DATALAKE_COMPANY = {
    cacheTime: 1000 * 60 * 3,
}
